import { css } from '@emotion/react';

export const layoutContentStyles = (noPadding: boolean) =>
  css({
    padding: noPadding ? '0px' : '15px',
    height: '100%',
    overflow: 'auto',
  });
